module.exports = __webpack_public_path__ + "img/01_abe_11.95514d54.jpg";